import { useState } from 'react';

import UPSPackagelessOption from './ReturnOptions/UPSPackagelessOption';
import WFMPackagelessOption from './ReturnOptions/WFMPackagelessOption';
import PrintLabelOption from './ReturnOptions/PrintLabelOption';
import PickupOption from './ReturnOptions/PickupOption';
import MailLabelOption from './ReturnOptions/MailLabelOption';
import LabellessOption from './ReturnOptions/LabellessOption';

import WholeFoodsIcon from 'images/zappos/WFM_logo.png';
import UPSIcon from 'images/zappos/ups-logo.svg';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import { UPS_RETURN_METHODS, WHOLE_FOODS_RETURN_METHODS } from 'constants/returnLabelOptions';

import css from 'styles/containers/returns/returnConfirmationLabelSection.scss';

const SHIPPING_METHOD_OPTIONS = {
  [PROVIDE_LABEL_OPTIONS.PRINT]: PrintLabelOption,
  [PROVIDE_LABEL_OPTIONS.PICKUP]: PickupOption,
  [PROVIDE_LABEL_OPTIONS.LABELLESS]: LabellessOption,
  [PROVIDE_LABEL_OPTIONS.MAIL]: MailLabelOption,
  [PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS]: UPSPackagelessOption,
  [PROVIDE_LABEL_OPTIONS.WFM_PACKAGELESS]: WFMPackagelessOption
};

const makeCategorizedTitle = (title, icon) => (
  <>
    <h2 className={css.categoryTitle}>
      <img className={css.categoryTitleIcon} src={icon} alt={'category icon'} />
      {title}
    </h2>
  </>
);

const ReturnConfirmationLabelSection = ({
  showLabellessReturns,
  customerInfo,
  labelDelivery,
  boxInfo,
  postReturnInfo,
  UPSPickUpAddress,
  showPackagelessReturn
}) => {
  const [showInstructions, setShowInstructions] = useState(null);
  const showInstructionsHandler = event => setShowInstructions(event.target.value !== showInstructions ? event.target.value : null);

  const DisplayOption = SHIPPING_METHOD_OPTIONS[labelDelivery];
  const displayOptionProps = {
    showLabellessReturns,
    labelDelivery,
    customerInfo,
    boxInfo,
    postReturnInfo,
    showInstructions,
    UPSPickUpAddress,
    showPackagelessReturn,
    displayOnly: true,
    showInstructionsHandler
  };
  // don't return anything if the option type is MAIL
  return (
    <>
      {labelDelivery !== PROVIDE_LABEL_OPTIONS.MAIL && (
        <div className={css.container}>
          {WHOLE_FOODS_RETURN_METHODS.includes(labelDelivery) && makeCategorizedTitle('Whole Foods Market', WholeFoodsIcon)}
          {UPS_RETURN_METHODS.includes(labelDelivery) && makeCategorizedTitle('UPS', UPSIcon)}
          <DisplayOption {...displayOptionProps} />
        </div>
      )}
    </>
  );
};

export default ReturnConfirmationLabelSection;
